import * as utility from './_utility.js';

// dispatch custom event to resize carousel
const changeFontEvent = new CustomEvent('changefont', {
    bubbles: true,
});

function dispatchChangeFontEvent(el) {
    setTimeout(
	el.dispatchEvent(
	    changeFontEvent
	), 500
    )
}

const enchanceReadabilitySwitcherId = 'enhance-readability-switcher';
const themeSwitcherId = 'theme-switcher';

const SWITCH_MAP = {
    [enchanceReadabilitySwitcherId]: {
	true: function() {
	    utility.setCssVariable(
		'--font-family',
		utility.getCssVariable('--ff-enhance-readability')
	    );
	    utility.setCookie(
		enchanceReadabilitySwitcherId,
		true
	    );
	    dispatchChangeFontEvent(
		document.getElementById(enchanceReadabilitySwitcherId)
	    )
	},
	false: function() {
	    utility.setCssVariable(
		'--font-family',
		utility.getCssVariable('--ff-base')
	    );
	    utility.eraseCookie(enchanceReadabilitySwitcherId);
	    dispatchChangeFontEvent(
		document.getElementById(enchanceReadabilitySwitcherId)
	    )
	},
    },
    [themeSwitcherId]: {
	// dark theme colors live in the CSS, under body.theme-dark
	true: function() {
	    document.body.classList.add('theme-dark');
	    utility.setCookie(
		themeSwitcherId,
		true
	    );
	},
	false: function() {
	    document.body.classList.remove('theme-dark');
	    utility.eraseCookie(themeSwitcherId);
	},
    },
} 

function addAriaLiveToActiveCarouselElement(evt) {
    evt.target.querySelectorAll('.carousel-item').forEach(function(el) {
	el.removeAttribute('aria-live');
	el.removeAttribute('aria-atomic');
    });
    evt.relatedTarget.setAttribute('aria-live', 'polite');
    evt.relatedTarget.setAttribute('aria-atomic', 'true');
}

export {SWITCH_MAP, addAriaLiveToActiveCarouselElement}
